import { useContext } from "react";

import AuthenticationContext from "../../../context/Authentication/AuthenticationContext.ts";

import { addCommas } from "@persian-tools/persian-tools";

import AdminOperation from "../../admin-panel/AdminOperation.jsx";
import { pathMaker } from "../../../utils/helperFunctions.js";
import { Link } from "react-router-dom";
import { calculatePrice } from "../../../utils/Helper.ts";
import Timer from "../../Pages/Timer/Timer.jsx";

export default function ProductCardCat({
  productData,
  setUpdater,
  setShowEditProductModal,
  setSelectedPRoduct,
  type = "original",
  loading,
  superAdminAccess = true,
  customClassName,
}) {
  console.log("productData", productData);
  const { userInfo } = useContext(AuthenticationContext);
  return (
    <div className={`position-relative product-card-cat ${customClassName} `}>
      {userInfo.userType == 0 && superAdminAccess && (
        <AdminOperation
          id={productData?.id}
          status={productData?.status}
          setUpdater={setUpdater}
          left="0"
          setShowEditProductModal={setShowEditProductModal}
          setSelectedPRoduct={setSelectedPRoduct}
          productData={productData}
        />
      )}
      {productData?.status == -1 && (
        <div
          className="position-absolute d-flex align-items-center justify-content-center font-14-600"
          style={{
            width: 100,
            height: "50px",
            top: 0,
            bottom: 0,
            backgroundColor: "lightgray",
            borderRadius: "0px 16px 0 16px",
            color: "#554949",
            zIndex: 1,
          }}
        >
          غیرفعال
        </div>
      )}
      {type == "original" ? (
        <Link
          to={`/product/${productData.id}`}
          className="accessories-products-card accessories-products-card1  h-100"
          style={{ textDecoration: "none", color: "inherit" }}
        >
          <div className="products-ad-box"></div>
          <div
            className="accessories-products-card-img"
            style={{
              borderBottom:
                productData.max_discount != "0" && !loading
                  ? "5px #ca0000 solid"
                  : "none",
              position: "relative",
            }}
          >
            {productData?.max_discount != "0" && !loading && (
              <span
                className="color-rd-02 font-18-500"
                style={{
                  position: "absolute",
                  zIndex: "5",
                  right: "6px",
                  bottom: "4px",
                }}
              >
                %{" "}
                {Math.floor(
                  (productData?.max_discount / productData?.min_price) * 100
                )}{" "}
                تخفیف
              </span>
            )}
            {loading ? (
              <div
                className="bg-gy-02 rd-t-16"
                style={{ width: "100%", height: "100%" }}
              ></div>
            ) : (
              <img
                src={pathMaker(productData?.file)}
                className="products-card-pic rd-t-16"
              />
            )}
            {productData?.type == 1 && (
              <div
                className="bg-rd-02 text-white pd-6 wd-40 font-12-500"
                style={{
                  position: "absolute",
                  top: 0,
                  right: 0,
                  borderRadius: "0 10px 0 10px",
                  whiteSpace: "wrap",
                }}
              >
                فروش آفلاین
              </div>
            )}
          </div>

          <div
            className={`pd-y-12  d-flex flex-column justify-content-between  ${
              "he-100"
              // type != "search" && "he-160"
            }`}
          >
            <div className="accessories-products-card-texts pd-x-12 mr-b-12 ">
              {loading ? (
                <div
                  className="bg-gy-02"
                  style={{ width: "100%", height: "20px" }}
                ></div>
              ) : (
                <span className="accessories-products-card-title">
                  {productData?.title}{" "}
                </span>
              )}
              {loading ? (
                <div
                  className="bg-gy-02"
                  style={{ width: "100%", height: "20px" }}
                ></div>
              ) : (
                // type != "search" && (
                false && (
                  <p
                    className="font-16-500 mr-b-0"
                    style={{ color: "#98A2B3", lineHeight: "150%" }}
                  >
                    {productData?.description}
                  </p>
                )
              )}
            </div>
            {productData?.max_discount_tm != "" &&
              parseInt(productData?.max_discount_tm) * 1000 >
                new Date().getTime() && (
                <div className="timer-style">
                  <Timer
                    expir={parseInt(productData?.max_discount_tm) * 1000}
                  />
                </div>
              )}

            <div
              className="accessories-products-card-price pd-x-16"
              style={{
                justifyContent:
                  +productData.max_discount === 0 ? "flex-end" : "",
              }}
            >
              {loading ? (
                <div
                  className="bg-gy-02"
                  style={{ width: "40%", height: "20px" }}
                ></div>
              ) : (
                <>
                  {productData.max_discount != "0" &&
                    !productData?.unavailable && (
                      <div className="mr-l-6 products-card-price-off d-flex align-items-center justify-content-between">
                        <span>{addCommas(+productData?.min_price)}</span>
                      </div>
                    )}
                  <div
                    className={`products-card-price d-flex ${
                      productData?.unavailable && "products-card-price-off"
                    }`}
                  >
                    {productData?.unavailable && (
                      <p className="mr-b-0 mr-l-4">ناموجود</p>
                    )}
                    <span>
                      {/* {addCommas(
                        calculatePrice({
                          discount: productData.max_discount,
                          price: productData.min_price,
                        })
                      )} */}
                      {addCommas(
                        parseInt(productData.min_price) -
                          parseInt(productData.max_discount)
                      )}
                      تومان
                    </span>
                  </div>
                </>
              )}
            </div>
          </div>
        </Link>
      ) : type == "offer" ? (
        <Link
          to={`/product/${productData.id}`}
          className="accessories-products-card accessories-products-card2  h-100"
          style={{ textDecoration: "none", color: "inherit" }}
        >
          <>
            <div
              className="accessories-products-card-img"
              style={{ position: "relative" }}
            >
              {loading ? (
                <div
                  className="bg-gy-02 rd-t-16"
                  style={{ width: "100%", height: "100%" }}
                ></div>
              ) : (
                <img
                  src={pathMaker(productData?.file)}
                  className="products-card-pic rd-t-16"
                />
              )}
              {productData?.type == 1 && (
                <div
                  className="bg-rd-02 text-white pd-6 wd-40 font-12-500"
                  style={{
                    position: "absolute",
                    top: 0,
                    right: 0,
                    borderRadius: "0 10px 0 10px",
                    whiteSpace: "wrap",
                  }}
                >
                  فروش آفلاین
                </div>
              )}
            </div>
            <div className="accessories-products-card-texts2 pd-x-12 mr-y-12 text-center">
              {loading ? (
                <div
                  className="bg-gy-02"
                  style={{ width: "100%", height: "20px" }}
                ></div>
              ) : (
                <span className="accessories-products-card-title">
                  {productData?.title}{" "}
                </span>
              )}
            </div>
          </>
        </Link>
      ) : (
        <Link
          to={`/product/${productData.id}`}
          className="accessories-products-card accessories-products-card1  h-100"
          style={{ textDecoration: "none", color: "inherit" }}
        >
          <div className="products-ad-box"></div>
          <div
            className="accessories-products-card-img"
            style={{
              borderBottom:
                productData.max_discount != "0" && !loading
                  ? "5px #ca0000 solid"
                  : "none",
              position: "relative",
            }}
          >
            {productData?.max_discount != "0" && !loading && (
              <span
                className="color-rd-02 font-18-500"
                style={{
                  position: "absolute",
                  right: "6px",
                  bottom: "4px",
                }}
              >
                % {productData?.max_discount} تخفیف
              </span>
            )}
            {loading ? (
              <div
                className="bg-gy-02 rd-t-16"
                style={{ width: "100%", height: "100%" }}
              ></div>
            ) : (
              <img
                src={pathMaker(productData?.file)}
                className="products-card-pic rd-t-16"
              />
            )}
            {productData?.type == 1 && (
              <div
                className="bg-rd-02 text-white pd-6 wd-40 font-12-500"
                style={{
                  position: "absolute",
                  top: 0,
                  right: 0,
                  borderRadius: "0 10px 0 10px",
                  whiteSpace: "wrap",
                }}
              >
                فروش آفلاین
              </div>
            )}
          </div>
          <div
            className={`pd-y-12  d-flex flex-column justify-content-between  ${
              type != "search" && "he-160"
            }`}
          >
            <div className="accessories-products-card-texts pd-x-12 mr-b-12 ">
              {loading ? (
                <div
                  className="bg-gy-02"
                  style={{ width: "100%", height: "20px" }}
                ></div>
              ) : (
                <span className="accessories-products-card-title">
                  {productData?.title}{" "}
                </span>
              )}
            </div>
            <div
              className="accessories-products-card-price pd-x-16"
              style={{
                justifyContent:
                  +productData.max_discount === 0 ? "flex-end" : "",
              }}
            >
              {loading ? (
                <div
                  className="bg-gy-02"
                  style={{ width: "40%", height: "20px" }}
                ></div>
              ) : (
                <>
                  {productData.max_discount != "0" && (
                    <div className="mr-l-6 products-card-price-off d-flex align-items-center justify-content-between">
                      <span>{addCommas(+productData?.min_price)}</span>
                    </div>
                  )}
                  <div className="products-card-price ">
                    <span>
                      {addCommas(
                        calculatePrice({
                          discount: productData.max_discount,
                          price: productData.min_price,
                        })
                      )}
                      تومان
                    </span>
                  </div>
                </>
              )}
            </div>
          </div>
        </Link>
      )}
    </div>
  );
}
